/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MergeCounselorDocumentsRequestItem
 */
export interface MergeCounselorDocumentsRequestItem {
    /**
     * 
     * @type {string}
     * @memberof MergeCounselorDocumentsRequestItem
     */
    documentId: string;
    /**
     * 
     * @type {number}
     * @memberof MergeCounselorDocumentsRequestItem
     */
    rotationDegrees: number;
}

/**
 * Check if a given object implements the MergeCounselorDocumentsRequestItem interface.
 */
export function instanceOfMergeCounselorDocumentsRequestItem(value: object): value is MergeCounselorDocumentsRequestItem {
    if (!('documentId' in value) || value['documentId'] === undefined) return false;
    if (!('rotationDegrees' in value) || value['rotationDegrees'] === undefined) return false;
    return true;
}

export function MergeCounselorDocumentsRequestItemFromJSON(json: any): MergeCounselorDocumentsRequestItem {
    return MergeCounselorDocumentsRequestItemFromJSONTyped(json, false);
}

export function MergeCounselorDocumentsRequestItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MergeCounselorDocumentsRequestItem {
    if (json == null) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'rotationDegrees': json['rotationDegrees'],
    };
}

export function MergeCounselorDocumentsRequestItemToJSON(json: any): MergeCounselorDocumentsRequestItem {
    return MergeCounselorDocumentsRequestItemToJSONTyped(json, false);
}

export function MergeCounselorDocumentsRequestItemToJSONTyped(value?: MergeCounselorDocumentsRequestItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documentId': value['documentId'],
        'rotationDegrees': value['rotationDegrees'],
    };
}

